import React from 'react'
import { Link } from 'react-router-dom'
import HeaderDiv from '../Header/HeaderDiv'
import { Layout, Menu, Icon } from 'antd'
import { withRouter } from 'react-router-dom'
import {
  TeamOutlined,
  SolutionOutlined,
  IdcardOutlined,
  SettingOutlined,
  CommentOutlined,
  RollbackOutlined,
  FileAddOutlined,
  ContainerOutlined,
} from '@ant-design/icons'
import hasPermissions from '../hooks/Permissions'
const { SubMenu } = Menu
const { Header, Sider, Content } = Layout
const data = JSON.parse(localStorage.getItem('user'))
class Layouts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      quotationPermissions: {},
      policyPermissions: {},
      customerPermissions: {},
      insurerSettingPermission: {},
      isSuperAdmin:
        data?.role === '301',
      isInsurer: data?.role === '308',
      LoginUserRole: JSON.parse(localStorage.getItem('roles')).toLowerCase(),
      collapsed: localStorage.getItem('collapsed') === 'true' || false,
      openKeys: [],
      selectedKeys: [this.getSelectedKey(props.location.pathname)]
    }
    this.rootSubmenuKeys = ['sub1', 'sub2', 'sub4', 'sub5', 'sub3', 'sub6']
  }

  // Helper function to map paths to menu keys
  getSelectedKey = (pathname) => {
    const pathToKeyMap = {
      '/dashboard': '1',
      '/customers': '2',
      '/quotations': '4',
      '/policies': '5',
      '/reports': '6',
      '/generate-quote': '12',
      '/communication': '7',
      '/reinsuranceReport': '13',
      '/debit-note': '8',
      '/customer-statement': '9',
      '/payment-history': '71',
      '/subsciption-settings': '72',
      '/insurer-products': '52',
      '/insurer-risk-cover-item': '54',
      '/insurer-risk-cover': '53',
      '/home': '18',
      '/endorsement-type': '55',
      '/laps-setting': '56',
    }

    // Find the matching path
    for (const [path, key] of Object.entries(pathToKeyMap)) {
      if (pathname.startsWith(path)) {
        return key
      }
    }

    return '1' // default to dashboard
  }

  componentDidUpdate(prevProps) {
    // Update selectedKeys when route changes
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({
        selectedKeys: [this.getSelectedKey(this.props.location.pathname)]
      })
    }
  }

  state = {
    collapsed: true,
    uni: '',
    location: '',
  }
  toggleSidebar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
    localStorage.setItem('collapsed', !this.state.collapsed)
  }
  rootSubmenuKeys = ['sub1', 'sub2', 'sub4', 'sub5', 'sub3', 'sub6']

  state = {
    openKeys: '',
    collapsed: false,
  }

  // onOpenChange = openKeys => {
  //   const prevOpenKeys = this.state.openKeys || []
  //   const latestOpenKey = openKeys.find(key => !prevOpenKeys.includes(key))

  //   if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
  //     this.setState({ openKeys })
  //   } else {
  //     this.setState({
  //       openKeys: latestOpenKey ? [latestOpenKey] : [],
  //     })
  //   }
  // }

  onOpenChange = openKeys => {
    const latestOpenKey = openKeys.find(key => !this.state.openKeys.includes(key))

    if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
      this.setState({ openKeys })
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : [],
      })
    }
  }

  componentDidMount() {
    // this.setState({location:location})
    const quotpermissions = hasPermissions('Quotation')
    const policypermissions = hasPermissions('Policy')
    const custpermissions = hasPermissions('Customers')
    const insurer_setting_permission = hasPermissions('Insurer Setting')

    this.setState({
      quotationPermissions: quotpermissions,
      policyPermissions: policypermissions,
      customerPermissions: custpermissions,
      insurerSettingPermission: insurer_setting_permission,
    })
  }
  render() {
    const active = this.props.active
    const { location } = this.props
    const isHomeRoute = location.pathname.startsWith('/home')
    const { isSuperAdmin } = this.state.isSuperAdmin
    // const classname = (this.props, "classname", " ");
    return (
      <Layout className={`${this.props.classname}`}>
        <Sider
          trigger={null}
          collapsible
          collapsed={this.state.collapsed}
          style={{
            background: '#001529',
            minWidth: '250px',
            width: '250px',
            maxWidth: '250px',
          }}
          // className={!isHomeRoute ? 'sidebar-left' : ''}
          className={`sidebar-left ${this.state.collapsed ? 'collapsed' : ''}`}
          onCollapse={this.onCollapse}>
          <div className="logo" />
          <Menu
            theme="light"
            mode="inline"
            selectedKeys={this.state.selectedKeys}
            openKeys={this.state.openKeys}
            onOpenChange={this.onOpenChange}
          >


            <Menu.Item key="18">
              <Link to="/home">
                <div>
                  <RollbackOutlined />
                  <span> Go Back</span>
                </div>
              </Link>
            </Menu.Item>
            {localStorage.getItem('productName') !== 'Select Product' && (
              <Menu.Item key="1">
                <Link to="/dashboard">
                  <div>
                    <Icon type="dashboard" />
                    <span>Dashboard </span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {Object.keys(this.state.customerPermissions).length > 0 && (
              <Menu.Item key="2">
                <Link to="/customers">
                  <div>
                    <TeamOutlined />
                    <span>Customers </span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {localStorage.getItem('productName') !== 'Select Product' && (
              <Menu.Item key="4">
                <Link to="/quotations">
                  <div>
                    {/* <Icon type="dashboard" /> */}
                    <SolutionOutlined />
                    <span>Quotations </span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {localStorage.getItem('productName') !== 'Select Product' && (
              <Menu.Item key="5">
                <Link to="/policies">
                  <div>
                    <IdcardOutlined />
                    <span>Policies </span>
                  </div>
                </Link>
              </Menu.Item>
            )}

            {this.state.LoginUserRole == 'customer' && localStorage.getItem('productName') !== 'Select Product' && (
              <Menu.Item key="12">
                <Link to="/generate-quote">
                  <div>
                    <FileAddOutlined />
                    <span>Generate Quote</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {(data.role === '311' || data.role === '305') && (
              <Menu.Item key="7">
                <Link to="/communication">
                  <div>
                    <CommentOutlined />
                    <span>Communication</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {(this.state.customerPermissions.hasOwnProperty('29')) && (<Menu.Item key="8">
              <Link to="/debit-note">
                <div>
                  <CommentOutlined />
                  <span>Debit Note</span>
                </div>
              </Link>
            </Menu.Item>)}
            {(this.state.customerPermissions.hasOwnProperty('30')) && (
              <Menu.Item key="9">
                <Link to="/customer-statement">
                  <div>
                    <SolutionOutlined />
                    <span>Statement</span>
                  </div>
                </Link>
              </Menu.Item>
            )}
            {(this.state.customerPermissions.hasOwnProperty('30')) && (
              <SubMenu
                key="sub2"
                title={
                  <span>
                    <SettingOutlined />
                    <span>Subscription</span>
                  </span>
                }>
                <Menu.Item key="71">
                  <Link to="/payment-history">Payment history</Link>
                </Menu.Item>
                <Menu.Item key="72">
                  <Link to="/subsciption-settings">Settings</Link>
                </Menu.Item>
              </SubMenu>
            )}
            {Object.keys(this.state.policyPermissions).length > 0 && (
              <SubMenu
                key="sub3"
                title={
                  <span>
                    <ContainerOutlined />
                    <span>Reports</span>
                  </span>
                }>
                <Menu.Item key="101">
                  <Link to="/reports">Policy Report</Link>
                </Menu.Item>

                <Menu.Item key="102">
                  <Link to="/ReinsuranceReport">Reinsurance Report</Link>
                </Menu.Item>

                <Menu.Item key="103">
                  <Link to="/ReinsurerAmountDueReport">Reinsurance Due Report</Link>
                </Menu.Item>

                <Menu.Item key="104">
                  <Link to="/BrokerPoliciesReport">Broker Policies Report</Link>
                </Menu.Item>

                <Menu.Item key="105">
                  <Link to="/ClaimPendingReport">Claim Pending Report</Link>
                </Menu.Item>

                <Menu.Item key="106">
                  <Link to="/ClaimSettledReport">Claim Settled Report</Link>
                </Menu.Item>

                <Menu.Item key="107">
                  <Link to="/ClaimRejectedReport">Claim Rejected Report</Link>
                </Menu.Item>

                <Menu.Item key="108">
                  <Link to="/ClaimFormReport">Claim Form Report</Link>
                </Menu.Item>


              </SubMenu>
            )}
            {this.state.isInsurer && (
              <SubMenu
                key="sub1"
                title={
                  <span>
                    <SettingOutlined />
                    <span>Master Settings</span>
                  </span>
                }>
                <Menu.Item key="52">
                  <Link to="/insurer-products">Manage Products</Link>
                </Menu.Item>
                <Menu.Item key="53">
                  <Link to="/insurer-risk-cover">Manage Risk Covers</Link>
                </Menu.Item>
                <Menu.Item key="54">
                  <Link to="/insurer-risk-cover-item">Manage Risk Items</Link>
                </Menu.Item>
                <Menu.Item key="57">
                  <Link to="/currency-rate">Manage Currency Rates</Link>
                </Menu.Item>
                <Menu.Item key="58">
                  <Link to="/stamp-duty">Manage Stamp Duty</Link>
                </Menu.Item>
                <Menu.Item key="55">
                  <Link to="/endorsement-type">Endorsement Types</Link>
                </Menu.Item>
                <Menu.Item key="56">
                  <Link to="/laps-setting">Manage Laps Period</Link>
                </Menu.Item>
              </SubMenu>
            )}
          </Menu>
        </Sider>
        <Layout>
          <Header className="headerTop">
            <HeaderDiv toggleSidebar={this.toggleSidebar} />
          </Header>
          <Content
            style={{
              padding: '65px , 35px',
              minHeight: '100vh',
            }}
            className={
              this.state.collapsed ? 'collapsed mainContnet ' : 'mainContnet'
            }
          >
            {this.props.children}
          </Content>
        </Layout>
      </Layout>
    )
  }
}
export default withRouter(Layouts)
